@if ({lead: lead(), number: number()}; as input) {
  <div>
    <mat-expansion-panel
      [expanded]="
        (routeInformationService.currentLead$ | async)?.id === input.lead.id
      "
      (opened)="routeInformationService.setCurrentLead(input.lead)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ input.number + ": " + input.lead.name }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-panel-content">
        <p>
          {{ addressToString(input.lead.address) }}
        </p>
        <p>
          <span class="item-label">
            {{
              ("components.selected-lead-list.lead-category" | translate) + ": "
            }}
          </span>
          <span class="item-value-block">
            {{ "enums.leadCategory." + input.lead.leadCategory | translate }}
          </span>
        </p>
        <p>
          <span class="item-label">
            {{
              ("components.selected-leads-routing.route-summary.openingTimes"
                | translate) + ": "
            }}
          </span>
          <span class="item-value-block">
            {{ compressedOpeningTimes }}
          </span>
        </p>
        <div>
          <span class="item-label">
            {{
              ("components.selected-lead-list.usage-spaces" | translate) + ": "
            }}
          </span>
          <div class="item-value-block">
            @if (input.lead.usageSpaces.length > 0) {
              @for (room of input.lead.usageSpaces; let i = $index; track i) {
                <span>
                  {{
                    room.info.name.trim() +
                    (i < input.lead.usageSpaces.length - 1 ? ", " : "")
                  }}
                </span>
              }
            } @else {
              <span>{{
                  "components.selected-lead-list.no-known-rooms" | translate
                }}</span>
            }
          </div>
        </div>
        <div class="button-row">
          <button mat-button (click)="gotoLeadDetail(input.lead)">
            {{ "components.selected-lead-list.start-button" | translate }}
          </button>
          <button mat-button (click)="openGoogleMaps(input.lead)">
            {{
              "components.selected-lead-list.open-google-maps-button"
                | translate
            }}
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
}
